{
    "warning": "ચેતવણી!",
    "message": "તમે સમજતા ન હો એવો કોડ લખશો કે પેસ્ટ કરશો નહીં.\nઆ કન્સોલનો ઉપયોગ કરવાથી હુમલાખોરો સેલ્ફ-XSS નામના હુમલાનો ઉપયોગ કરીને તમે હોવાનું અનુકરણ કરી શકે છે અને તમારી માહિતી ચોરી શકે છે."
}
